import { type ReactNode, type RefObject, useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { useZoomInfo } from './ZoomInfoProvider';

export const NodeLink = ({ nodeRef, children }: { nodeRef: RefObject<HTMLDivElement | null>; children: ReactNode }) => {
  const [linePath, setLinePath] = useState<{
    lineX: number;
    lineY: number;
    length: number;
    angle: number;
  } | null>(null);
  const lineRef = useRef<HTMLDivElement>(null);
  const zoom = useZoomInfo();

  useEffect(() => {
    const parent = nodeRef?.current?.parentElement as HTMLDivElement;
    if (nodeRef?.current && parent) {
      connect(nodeRef.current, parent);
    }
  }, []);

  function connect(self: HTMLDivElement, parent: HTMLDivElement) {
    const style = window.getComputedStyle(self);
    const gameScale = Number(style.getPropertyValue('--game-scale')) || 1;

    const selfRect = self.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    let xOffset = selfRect.width / 2;
    let yOffset = selfRect.height / 2;

    const x1 = parentRect.x - xOffset / 2;
    const y1 = parentRect.y - yOffset / 2;
    const x2 = selfRect.x - xOffset / 2;
    const y2 = selfRect.y - yOffset / 2;

    const dx = x2 - x1;
    const dy = y2 - y1;
    const length = Math.sqrt(dx * dx + dy * dy) / (zoom * gameScale);
    const angle = (Math.atan2(dx, dy) * 180) / Math.PI;

    setLinePath({ lineX: x1, lineY: y1, length, angle });
  }

  if (!linePath) {
    return null;
  }

  return (
    <div
      ref={lineRef}
      style={{
        transform: `rotate(${180 - linePath.angle}deg)`,
        height: linePath.length,
      }}
      className={styles.connector}
    >
      {children}
    </div>
  );
};
